import React from "react";

const SoldOutOverlay = ({ isMobile }) => (
  <div
    className="absolute inset-0 flex items-center justify-center mobile:rounded-lg tablet:rounded-2xl tablet-portrait:rounded-2xl desktop:rounded-3xl"
    style={{
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center bottom",
      backgroundImage:
        "linear-gradient(to bottom right, rgba(0, 47, 75, .5), rgba(220, 66, 37, .5))",
      backgroundSize: "cover",
    }}
  >
    <h2 className="m-0 text-white z-10 w-full text-center">
      SOLD OUT
    </h2>
  </div>
);

export default SoldOutOverlay;
